export default "__VITE_ASSET__Bel5__2G__"